import { Fragment, useCallback } from "react";
import PopUp from "./PopUp";
import styles from "./ErrorPopUp.module.css";

const ErrorPopUp = ({ error, onSetError }) => {
  const closePopUpHandler = useCallback(() => {
    onSetError("");
  }, [onSetError]);
  return (
    <Fragment>
      {error && (
        <PopUp onClick={closePopUpHandler} className={styles.error_popup}>
          <h1>Please provide a value</h1>
          <button onClick={closePopUpHandler}>Ok</button>
        </PopUp>
      )}
    </Fragment>
  );
};

export default ErrorPopUp;
